import { render } from "./AlzataResetPassword.vue?vue&type=template&id=5aeb8479"
import script from "./AlzataResetPassword.vue?vue&type=script&lang=js"
export * from "./AlzataResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__